import Testimonialimg from "../assests/Images/testimonial_image.jpg";
import '../styles/reviews.css';
import React, { useState, useEffect, useRef } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import '../../node_modules/swiper/swiper-bundle.min.css';
import left from '../assests/Images/left.png';
import right from '../assests/Images/right.png';
import AOS from "aos";
import "aos/dist/aos.css";
const testimonials = [
  {
    id: 1,
    text: "The Marine mentors were very knowledgeable and provided valuable insights into the maritime job market. They helped me identify suitable job opportunities and guided me through the application process. The only downside was the occasional delay in response time",
    name: "John Evans",
    position: "Engineer L2",
  },
  {
    id: 2,
    text: "I had a positive experience with the Marine mentors' consultant service. The team was attentive and responsive to my queries. They offered practical advice and helped me improve my resume, which led to multiple job offers. Great service overall!",
    name: "John Evans",
    position: "Engineer L2",
  },
  {
    id: 3,
    text: "Top-notch service! The Marine mentors were professional and went above and beyond to assist me with my career goals. They helped me prepare for interviews and provided excellent resources for continuous learning. I couldn't be happier with the results.",
    name: "John Evans",
    position: "Engineer L2",
  },
  {
    id: 4,
    text: "I had an excellent experience with the Marine mentors consultant service. Their team was knowledgeable and provided valuable guidance throughout my job search. Thanks to their support, I secured a great position on a reputable vessel. Highly recommend!",
    name: "John Evans",
    position: "Engineer L2",
  },
];

const Reviews = ({anim}) => {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    const [repeatedIndex, setRepeatedIndex] = useState(0); // For Repeated pagination
  const handleSlideChangeRepeated = (swiper) => setRepeatedIndex(swiper.activeIndex);
  const swiperRef = useRef(null);
  // Update window width when the window is resized
  useEffect(() => {
     if (anim!=="true") {
                  AOS.init({
                    duration: 1000, // Optional: you can customize the animation duration or other settings
                    once: true, // Optional: ensures animations only trigger once
                    startEvent: 'DOMContentLoaded', // Optional: triggers AOS on specific event
                    // offset: 100,
                  });
                }
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [anim]);

  const scrollLeft = ()=>{
    if(swiperRef.current){
      swiperRef.current.swiper.slidePrev();
    }
  }
  const scrollRight = ()=>{
    if(swiperRef.current){
      swiperRef.current.swiper.slideNext();
    }
  }

  const getAosData = (anima, delay) => {
    return anim==="true"? null : { "data-aos": anima, "data-aos-delay": delay };
  };


  // Set items per page based on window width (1 item for mobile, 3 items for desktop)
  // const itemsPerPage = windowWidth < 768 ? 1 : windowWidth < 1023 ? 2 : 3;
  const itemsPerPage = windowWidth >= 1024 ? 3 : windowWidth >= 768 ? 2 : 1; // Adjust slides per view based on screen size
  const totalreviews = testimonials.length-itemsPerPage;
  return (
    <div className="services-card-section">
      <div className="d-flex justify-content-center align-items-center">
        <div className="d-flex justify-content-center align-items-center flex-column">
          <h4  {...getAosData("fade-left",0)}  className="fs-2">Reviews</h4>
          <h6 {...getAosData("fade-up",100)}  className="section-title w-auto mt-2 mb-2 fs-5 my-3">What students say about us?</h6>
          <h6  {...getAosData("fade-up",100)} className="section-title fs-5 text-secondary fw-medium">
            "Setting sail with peace of mind - our top priority for every seafarer"
          </h6>
        </div>
      </div>
      <div className="d-flex justify-content-between align-items-center mt-5">
        <button  {...getAosData("fade-left",300)}  onClick={()=>scrollLeft()} className="service-cursor-btn reviews-cursorl" id="reviews-l-button"><img src={left} alt="Previous" /></button>

      <Swiper
       {...getAosData("fade-up",400)} 
        spaceBetween={20}
        slidesPerView={itemsPerPage}  // Dynamically adjust number of slides per view based on window size
        breakpoints={{
          320: { slidesPerView: 1 },
    768: { slidesPerView: 2 }, // Tablet view
    1024: { slidesPerView: 3 }, // Desktop view
        }}
        onSlideChange={handleSlideChangeRepeated}
        ref={swiperRef}
      >
        {testimonials.map((testimonial) => (
          <SwiperSlide key={testimonial.id}>
            <div className="testimonial-card">
              <p className="py-4">{testimonial.text}</p>

              <div className="d-flex gap-3 justify-content-between align-items-center">
                <div className="ratings-container">
                  {[...Array(5)].map((_, index) => (
                    <svg
                      key={index}
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      fill="currentColor"
                      className="bi bi-star-fill"
                      viewBox="0 0 16 16"
                    >
                      <path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z" />
                    </svg>
                  ))}
                </div>
                <div id="testimonial-info3" className="d-flex justify-content-center align-items-center">
                  <div className="testimonial-img">
                    <img src={Testimonialimg} alt="testimonial" />
                  </div>
                  <div className="testimonial-info">
                    <h6>{testimonial.name}</h6>
                    <p>{testimonial.position}</p>
                  </div>
                </div>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
      <button {...getAosData("fade-right",300)}  onClick={()=>scrollRight()}  className="service-cursor-btn reviews-cursorr"><img src={right} alt="Next" /></button>
</div>
      <div {...getAosData("fade-up",400)}  className="slider-nav">
          <div className="circles">
            {Array.from({ length: totalreviews+1 }).map((_, index) => (
              <span
                key={index}
                className={index === repeatedIndex ? 'circle active' : 'circle'}
              ></span>
            ))}
          </div>
        </div>
      
    </div>
  );
};

export default Reviews;
